import { createSelector } from 'reselect';
import get from 'lodash/get';

const selectAuthState = state => get(state, 'auth');

export const selectChangePasswordProcess = createSelector(
  selectAuthState,
  auth => get(auth, 'changePasswordProcess'),
);

export const selectChangePasswordProcessFormData = createSelector(
  selectChangePasswordProcess,
  state => get(state, 'changePasswordFormData'),
);



// WEBPACK FOOTER //
// ./src/redux/auth/changePassword/selectors.js